import { makeVar } from "@apollo/client";

import { ShadowTeamFormation } from "@/generated/graphql";
/**
 *
 */
export interface IShadowTeam {
  name: string;
  formation?: ShadowTeamFormation | null;
  id: string;
}
/**
 *
 */
export interface IAssignPlayer {
  /** Backend-canonical display name (SE-5469). */
  name?: string;
  firstName?: string;
  lastName?: string;
  knownName?: string;
  playerId?: string;
  shadowPlayerId: string;
  position: number;
  order: number;
  gpr?: number;
}

/**
 *
 */
export interface PlayerSelectPosition {
  /** Backend-canonical display name (SE-5469). */
  name?: string;
  firstName?: string;
  lastName?: string;
  knownName?: string;
  id: string;
  order: number;
  playerId: string;
  position: number;
  updatedAt: string;
}

/**
 *
 */
export interface IPlayerSoccer {
  /** Backend-canonical display name (SE-5469). */
  name?: string;
  firstName?: string;
  lastName?: string;
  knownName?: string;
  gpr?: number;
  playerId: string;
  shadowPlayerId: string;
}
export const selectedShowTeamVar = makeVar<IShadowTeam | undefined>(undefined);
export const searchTextPlayerVar = makeVar<string>("");
export const soccerSelectPositionVar = makeVar<number | undefined>(undefined);
export const hoveredPlayerIdVar = makeVar<string | undefined>(undefined);
export const exportToPdfVar = makeVar<boolean>(false);

/**
 * Open state for the position-scoped Add Player modal (shadow-teams-ux-v2 flag).
 * When `isOpen` is true with a `position`, the Add Player modal opens scoped to that pitch slot.
 */
export interface IAddPlayerModal {
  isOpen: boolean;
  position?: number;
  positionLabel?: string;
}
export const defaultAddPlayerModal: IAddPlayerModal = { isOpen: false };
export const addPlayerModalVar = makeVar<IAddPlayerModal>(
  defaultAddPlayerModal
);

/**
 * Open state for the "more players at this position" modal — opened by
 * clicking a pitch chip. Lists every player stacked at a position and links
 * each to their player-detail page.
 */
export interface IViewMorePositionPlayer {
  isOpen: boolean;
  position: number;
  players: IPlayerSoccer[];
}
export const defaultViewMorePositionPlayer: IViewMorePositionPlayer = {
  isOpen: false,
  position: 0,
  players: [],
};
export const viewMorePositionPlayerVar = makeVar<IViewMorePositionPlayer>(
  defaultViewMorePositionPlayer
);

/**
 * React-level override for an in-flight pitch drag-and-drop move. Mirrors
 * the player-kanban `pendingMoves` pattern (SE-4272) to mask Apollo's
 * ghost-broadcast window between optimistic-layer removal and server-
 * response write on mutation resolve — without this, the moved chip
 * briefly renders at its origin slot for one frame before settling.
 *
 * Keyed on `shadowPlayerId` (the ShadowTeamPlayer junction row id). The
 * `moveId` scopes cleanup so a rapid second drag of the same chip is
 * never wiped by the first drag's stale error handler.
 */
export interface IPendingPitchMove {
  position: number;
  order: number;
  moveId: string;
}
export const pendingPitchMovesVar = makeVar<Map<string, IPendingPitchMove>>(
  new Map()
);

/**
 * Preview roster state for displaying a team's roster on the main soccer field
 */
export interface IPreviewRoster {
  /** Whether preview mode is active */
  isActive: boolean;
  /** Team name being previewed */
  teamName: string;
  /** Starting XI to display on the pitch (capped to the 11 formation slots). */
  players: IAssignPlayer[];
  /**
   * Full previewed-team roster for the "Added players" sidebar (SE-5463). The
   * pitch stays capped to `players`; the sidebar lists every roster player,
   * grouped by role (XI in their slots, the rest as depth). Empty falls back
   * to `players`.
   */
  rosterPlayers: IAssignPlayer[];
}

/** Default preview roster state */
export const defaultPreviewRoster: IPreviewRoster = {
  isActive: false,
  teamName: "",
  players: [],
  rosterPlayers: [],
};

/** Reactive variable for roster preview mode */
export const previewRosterVar = makeVar<IPreviewRoster>(defaultPreviewRoster);
